<template>
<div class="chapter">
<div class="inner_page">
<div class="otherbooks" id="adc">
<p class="nonindent">Also by Robert K. Wilcox</p>
<p class="extract"><em>Black Aces High</em></p>
<p class="nonindent"><em>Wings of Fury</em></p>
<p class="nonindent"><em>Scream of Eagles</em></p>
<p class="nonindent"><em>Japan’s Secret War</em></p>
<p class="nonindent"><em>Fatal Glimpse</em></p>
<p class="nonindent"><em>Shroud</em></p>
<p class="nonindent"><em>The Mysterious Deaths at Ann Arbor</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312322496_epub_adc_r1.vue?c60179bc